<template>
  <div class='custom-node-properties'>
    <div class='custom-node-properties__header'>
      <div>
        <v-icon>home</v-icon>
      </div>
      <div class='custom-node-properties__header__title'>
        <div class='custom-node-properties__header__title__name'>
          {{name}}
        </div>
        <div class='custom-node-properties__header__title__type'>
          {{$t(`ctc.properties.type.${data.type.toLowerCase()}`)}}
        </div>
      </div>
    </div>
    <v-expansion-panels multiple v-model="panels" flat>
      <v-expansion-panel>
        <v-expansion-panel-header class='panel-header'>{{$t('ctc.properties.general.title')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="general-content">
            <div class="general-row">
              <div class="node-label">{{$t('ctc.properties.node.name')}}</div>
              <v-text-field
                v-model="nodeName"
                :label="$t('ctc.properties.node.name')"
                solo
                dense
                outlined
                @change="updateName"
                class="node-name-input"
              />
            </div>
            <div class="general-row">
              <div class="node-label">{{$t('ctc.properties.node.icon')}}</div>
              <v-select
                v-model="icon"
                :items="iconOptions"
                :label="$t('ctc.properties.node.icon')"
                solo
                dense
                outlined
                autofocus
                :append-icon="'expand_more'"
                @change="updateIcon"
                class="node-icon-input"
                item-text="name"
                item-value="value"
                st
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      <div style='display: flex; flex-direction: row; align-items: center; justify-content: flex-start;'>
                        <img :src="require(`@/assets/icons/ctc/${item.value}.svg`)" height='24px' alt='' class='ctc-icon' style='margin-right: 10px'/>
                        <div>{{ item.name }}</div>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="icon-select-item">
                    <img :src="require(`@/assets/icons/ctc/${item.value}.svg`)" class="icon-preview" alt=''/>
                    <div>{{ item.name }}</div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'CustomNodeProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        type: 'custom',
        icon: '',
        name: '',
      }),
    },
  },
  data() {
    return {
      panels: [0],
      nodeName: '',
      icon: '',
      iconOptions: [
        { name: 'TA', value: 'actor' },
        { name: 'Custom', value: 'custom' },
        { name: 'Domain', value: 'domain' },
        { name: 'Email', value: 'email' },
        { name: 'IP', value: 'ip' },
        { name: 'Phishing', value: 'phishing' },
        { name: 'Subdomain', value: 'subdomain' },
        { name: 'Threat', value: 'threat' },
      ],
    };
  },
  computed: {
    name() {
      return this.nodeName.length > 0 ? this.nodeName : this.data.name;
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.nodeName = newData.name || '';
          this.icon = newData.icon || '';
        }
      },
    },
  },
  methods: {
    updateName() {
      this.$emit('property-changed', {
        type: 'custom',
        name: this.nodeName,
        icon: this.icon,
      });
    },
    updateIcon() {
      this.$emit('property-changed', {
        type: 'custom',
        name: this.nodeName,
        icon: this.icon,
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.custom-node-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);
    &__title{
      display: flex;
      flex-direction: column;
      margin-left: rem(15);
      &__name{
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
      };
      &__type{
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      };
    };
  }
  .panel-header {
    color: var(--text-primary);
    font-family: $font-family-medium;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    text-transform: uppercase;
  }
  .general-content {
    padding: rem(10);
  }
  .general-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: rem(15);
    .node-label {
      min-width: rem(100);
      color: var(--text-tertiary);
      font-family: $font-family-regular;
      font-size: rem(10);
      letter-spacing: 1.1px;
      text-transform: uppercase;
      align-items: center;
    }
    .node-name-input,
    .node-icon-input {
      margin-top: 0 !important;
      max-width: rem(120);
    }
    .icon-select-item{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    .icon-preview {
      width: rem(16);
      height: rem(16);
      margin-right: rem(3);
      margin-left: rem(-8);
    }
  }
}
</style>

<style lang="scss">
.custom-node-properties {
  .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: transparent;
  }
}

// Fix CTC SVG icons in dark mode
.theme--dark .ctc-icon,
.theme--dark .icon-preview {
  filter: invert(1);
}
</style>
